function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#148CFC",
  fillRule: "evenodd",
  d: "M8 15.111A7.111 7.111 0 1115.111 8 7.111 7.111 0 018 15.111zM8 2.074a5.926 5.926 0 00-5.896 5.333h7.428L7.284 5.164a.593.593 0 01.84-.839l3.266 3.26a.592.592 0 010 .84l-3.266 3.26a.593.593 0 11-.84-.839l2.259-2.253H2.104A5.926 5.926 0 108 2.074z"
});

var SvgGo = function SvgGo(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref);
};

export default SvgGo;